
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    loadOwnerProfileData: null,
    isLoadingGetLoadOwnerProfile: false,

    photoList: [],
    currentPhotoItemId: null,

    locationList:  [
        { lat: 36.907627, lng: 30.702667 },
        { lat: 36.920254, lng: 30.722580 },
        { lat: 36.854488, lng: 30.766697 },
    ] 
}

export const getLoadOwnerProfile = createAsyncThunk("loadOwner/getLoadOwnerProfile", async({page, companyId}, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.get(`/Companies/GetCompanyLoadsNDocs?page=${0}&&stateOfAspiredLoad=${1}&&companyId=${companyId}`)
        
        return {companyDoc: data?.companyDoc?.data, companyInfo: data?.companyInfo, companyLoads: data?.companyLoads}
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

const loadOwnerSlice = createSlice({
    name: "loadOwner",
    initialState,
    reducers: {
        setPhotoList: (state, action) => {
            const {currentPhotoItemId, photoList} = action.payload
            state.photoList = photoList
            state.currentPhotoItemId = currentPhotoItemId 
        }

    },
    extraReducers:(builder)=> {
        builder

        .addCase(getLoadOwnerProfile.pending, (state)=> {
            state.isLoadingGetLoadOwnerProfile = true
        })
        .addCase(getLoadOwnerProfile.fulfilled, (state, action)=> {
            state.isLoadingGetLoadOwnerProfile = false
            state.loadOwnerProfileData = action.payload
            
        })
        .addCase(getLoadOwnerProfile.rejected, (state, action)=> {
            state.isLoadingGetLoadOwnerProfile = false
        })

    }
})


export const {setPhotoList} = loadOwnerSlice.actions
export default loadOwnerSlice.reducer